import Swiper from 'swiper';
import { AlpineComponent } from 'alpinejs';
import { Navigation } from 'swiper/modules';

export default (): AlpineComponent => ({
    init(): void {
        const swiperElement = this.$el.getElementsByClassName('swiper');
        const swiper = new Swiper(swiperElement[0], {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            mousewheel: true,
            keyboard: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });
    },
});